var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvocate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0632,
    cy: 35.0269,
    r: 35,
    transform: "rotate(0.0280528 35.0632 35.0269)",
    fill: "#1EA2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9728 20.9592V19H27.4898V37.7211H29.6667V20.9592H30.9728Z",
    fill: "url(#paint0_linear_2699_4774)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.619 24.6599V22.7007H23.3537V37.7211H25.3129V24.6599H26.619Z",
    fill: "url(#paint1_linear_2699_4774)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.483 28.5782V26.4014H19V37.7211H21.1769V28.5782H22.483Z",
    fill: "url(#paint2_linear_2699_4774)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2789 21.1769V19H43.5986V22.483H41.4218V20.9592L32.2789 21.1769Z",
    fill: "url(#paint3_linear_2699_4774)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0612 25.5306V23.1361H47.2993V26.8367H45.1224V25.5306H32.0612Z",
    fill: "url(#paint4_linear_2699_4774)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0612 29.8844V27.7075H51V31.1905H48.8231V29.8844H32.0612Z",
    fill: "url(#paint5_linear_2699_4774)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43.5986V32.0612H48.8231V41.6395H47.2993V43.5986H51Z",
    fill: "url(#paint6_linear_2699_4774)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6463 32.0612H44.4694V45.1224H43.1633V47.2993H46.6463V32.0612Z",
    fill: "url(#paint7_linear_2699_4774)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2925 32.0612H40.1156V49.0408H38.8095V51H42.2925V32.0612Z",
    fill: "url(#paint8_linear_2699_4774)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1769 38.8095H19V42.2925H37.7211V40.3333H21.1769V38.8095Z",
    fill: "url(#paint9_linear_2699_4774)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8776 43.381H22.7007V46.6463H37.7211V44.4694H24.8776V43.381Z",
    fill: "url(#paint10_linear_2699_4774)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5782 47.7347H26.1837V51H37.7211V49.0408H28.5782V47.7347Z",
    fill: "url(#paint11_linear_2699_4774)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2699_4774",
    x1: 33.1497,
    y1: 30.7551,
    x2: 20.3061,
    y2: 48.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvocate);
export default __webpack_public_path__ + "static/media/Advocate.88bca3d5f16b027be1132e2672015dc8.svg";
export { ForwardRef as ReactComponent };